import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the bonus report view.
 * @extends JetView
 */
export default class tableBonusReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 60,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId',
                                    header: _('ID Cliente'), // Localized header
                                    width: 60,
                                    sort: 'int',
                                },
                                {
                                    id: 'UsuidReferred',
                                    header: _('ID Referido'),
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'PartnerBonusId',
                                    header: _('Id Bono'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'PartnerBonusName',
                                    header: _('Nombre de Bono'),
                                    width: 500,
                                    sort: 'int',
                                },
                                {
                                    id: 'BeginningDate',
                                    header: _('Fecha Inicio'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'AcceptanceDateLocal',
                                    header: _('Fecha Aceptación'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'BonusType',
                                    header: _('Tipo'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'),
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha Modificación'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'AmountConverted',
                                    header: _('Monto Convertido'),
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'RolloverRequired',
                                    header: _('Rollover Requerido'),
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'RolloverWagered',
                                    header: _('Apostado'),
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'RolloverRemaining',
                                    header: _('Restante'),
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ClientBonusExpirationDateLocal',
                                    header: _('Fecha Expiración'),
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    // Event handler for detail icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Call event with user ID
                                    ]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show(); // Show filter details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                    }
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReport?PlayerId=' + cur_user + '&'; // API URL for fetching bonus report
        var filter = ''; // Filter string

        // Event listener for bonus report filter
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to filter
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });

        // Popup window for adding bonus balance
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddBonusBalance', // Unique ID for the popup
            width: 450,
            height: 450,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Añadir bono a saldo'), // Label for the popup
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            position: 'center', // Center position of the popup
            modal: true, // Modal popup
            body: {
                view: 'form',
                id: 'addform', // Unique ID for the form
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Id'), // User ID field
                        value: cur_user, // Set current user ID as value
                        name: 'UserId',
                        type: 'number',
                        labelWidth: 150,
                        required: false,
                        readonly: true, // Make field read-only
                    },
                    {
                        view: 'combo',
                        label: _('Tipo'), // Type selection
                        name: 'Type',
                        required: true,
                        options: [
                            // Options for type
                            { id: '0', value: _('Premio Torneo Casino') },
                            { id: '1', value: _('Premio Torneo Deportivas') },
                            { id: '2', value: _('Premio Torneo Virtuales') },
                            {
                                id: '3',
                                value: _('Premio Torneo Casino en Vivo'),
                            },
                            { id: '4', value: _('Sorteos') },
                            { id: '5', value: _('Sorteos Casino') },
                            { id: '6', value: _('Sorteos Virtuales') },
                            { id: '7', value: _('Sorteos Casino en Vivo') },
                        ],
                        labelWidth: 150,
                    },
                    {
                        view: 'combo',
                        label: _('Tipo Saldo:'), // Balance type selection
                        name: 'TypeBalance',
                        required: true,
                        options: [
                            { id: '0', value: _('Saldo recargas') },
                            { id: '1', value: _('Saldo premios') },
                        ],
                        labelWidth: 150,
                    },
                    {
                        view: 'text',
                        label: _('Referencia'), // Reference field
                        name: 'Reference',
                        labelWidth: 150,
                        required: false,
                    },
                    {
                        view: 'text',
                        label: _('Valor'), // Value field
                        name: 'Value',
                        type: 'number',
                        labelWidth: 150,
                        required: true,
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Bonus/AddBonusBalance', // API endpoint for adding bonus balance
                                                '{"UserId":"' +
                                                    cur_user +
                                                    '", "Type":"' +
                                                    values.Type +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Reference":"' +
                                                    values.Reference +
                                                    '", "Value":"' +
                                                    values.Value +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-error',
                                                                text: json.AlertMessage, // Show alert message on error
                                                            });
                                                        } else {
                                                            webix.message(
                                                                'Bono a saldo añadido correctamente', // Show success message
                                                            );
                                                            grid.clearAll(); // Clear grid data
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Show validation error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for showing the add bonus balance popup
        this.on(this.app, 'addBonusBalance:button', (filter) => {
            popupAdd.show(); // Show the popup
            $$('addform').clearValidation(); // Clear validation messages
        });
    }
}

// FILE DOCUMENTED
